import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { TableCell } from '@nagel-types';
import { TemperatureIconComponent } from '../../../../temperature-icon/temperature-icon.component';

@Component({
    selector: 'app-temperature-cell',
    imports: [TemperatureIconComponent],
    templateUrl: './temperature-cell.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class TemperatureCellComponent {
    cell = input.required<TableCell>();

    readonly temperature = computed(() => Number(this.cell().value));
}
